import 'matchmedia-polyfill';
import 'matchmedia-polyfill/matchMedia.addListener';
import _packages from './fakeApi/packages.json';

export function identifyScreen(minWidth) {
    return window.matchMedia(`(min-width: ${minWidth}px)`).matches ? "desktop" : "mobile"
}

export function loadPackages(callback) {
    setTimeout(() => {
      callback({
        packs: _packages,
        loadingPackages:false
      })
    }, 200);
  }